import Vue from 'vue'
import Vuetify from 'vuetify'

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#462279',
        secondary: '#10b981',
        accent: '#f59e0b',
        info: '#0ea5e9',
        success: '#22c55e',
        warning: '#fbbf24',
        error: '#ef4444',
        background: '#f3f4f6',
      },
      dark: {
        primary: '#462279',
        secondary: '#34d399',
        accent: '#f97316',
        info: '#38bdf8',
        success: '#4ade80',
        warning: '#facc15',
        error: '#f87171',
        background: '#111827',
      },
    },
  },
})
